import React from 'react';
import { isEmpty } from 'lodash';
import './AlarmValuesDisplay.scss';
// Material Ui
import { Box, Grid } from '@mui/material';
import AlarmValue from './AlarmValue';

interface AlarmStatisticElement {
  alarmsByLevels?: { [key: string]: string }; // Optional object with key-value pairs
  icon?: string; // Optional string for icon
  value?: string; // Optional string for value
  name: string;
}

const AstronautSeverityTypes = ['EMERGENCY', 'CRITICAL', 'ERROR', 'WARNING'];

const VectorSeverityTypes = ['CriticalAlarm', 'NonCriticalAlarm'];

const iconMapping = {
  EMERGENCY: 'lely-icon-emergency',
  CRITICAL: 'lely-icon-error',
  DEFAULT: 'lely-icon-alarm',
};

export default function AlarmValuesDisplay({
  title,
  alarmsData,
  externalId,
  kpiDetails,
  is24h,
}: {
  title: string;
  alarmsData: AlarmStatisticElement[];
  externalId: string;
  kpiDetails: { type: string };
  is24h: boolean;
}): JSX.Element {
  const isVector = kpiDetails.type === 'VectorSystem';
  const generateSeverityAlarmComponents = () => {
    const severityAlarmValueJSXElements: JSX.Element[] = [];
    alarmsData.forEach((currentElement: AlarmStatisticElement) => {
      if (
        (currentElement.alarmsByLevels &&
          !isEmpty(currentElement.alarmsByLevels)) ||
        currentElement.name === 'Last 24h' ||
        currentElement.name === 'Last week'
      ) {
        if (isVector) {
          VectorSeverityTypes.forEach((currentLevel) => {
            const alarmValue =
              (currentElement &&
                currentElement.alarmsByLevels &&
                currentElement.alarmsByLevels[currentLevel]) ??
              0;
            const iconType = 'lely-icon-alarm';
            severityAlarmValueJSXElements.push(
              <AlarmValue
                alarmValue={alarmValue}
                iconType={iconType}
                cssClassname={currentLevel.toLowerCase()}
                externalId={externalId}
                is24h={is24h}
                isVector={isVector}
              />,
            );
          });
        } else {
          AstronautSeverityTypes.forEach((currentLevel) => {
            const alarmValue =
              (currentElement &&
                currentElement.alarmsByLevels &&
                currentElement.alarmsByLevels[currentLevel]) ??
              0;
            const iconType = iconMapping[currentLevel] || iconMapping.DEFAULT;

            severityAlarmValueJSXElements.push(
              <AlarmValue
                alarmValue={alarmValue}
                iconType={iconType}
                cssClassname={currentLevel.toLowerCase()}
                externalId={externalId}
                is24h={is24h}
                isVector={isVector}
              />,
            );
          });
        }
      }
    });
    return severityAlarmValueJSXElements;
  };

  const generateIconAlarmComponents = () => {
    const iconAlarmJSXElements: JSX.Element[] = [];
    alarmsData.forEach((currentElement: AlarmStatisticElement) => {
      const alarmValue = currentElement.value ?? '';
      const alarmIconType = currentElement.icon ?? '';
      if (alarmIconType !== '') {
        iconAlarmJSXElements.push(
          <AlarmValue
            alarmValue={alarmValue}
            iconType={alarmIconType}
            is24h={is24h}
            externalId={externalId}
            isVector
          />,
        );
      }
    });
    return iconAlarmJSXElements;
  };
  return (
    <Grid size={12}>
      <div className="fs--b-base">{title}</div>
      <Box
        display="grid"
        alignItems="center"
        gridTemplateColumns="repeat(auto-fit, minmax(35px, 50px))"
        gap={1.25}
        height={25}
        marginBottom={0.5}
      >
        {generateSeverityAlarmComponents()}
      </Box>
      {isVector ? (
        <Box
          display="grid"
          alignItems="center"
          gridTemplateColumns="repeat(auto-fit, minmax(35px, 50px))"
          gap={1.25}
          height={25}
          marginBottom={0.5}
        >
          {generateIconAlarmComponents()}
        </Box>
      ) : (
        ''
      )}
    </Grid>
  );
}
